import * as yup from 'yup';
import { predecessorsRule } from 'utils/validation-rules';

export const PhaseItemModalSchema = yup.object({
  phaseId: yup.number().required('Field is required'),
  title: yup.string().required('Field is required').max(100, 'Max 100 characters'),
  startDate: yup.string().required('Field is required'),
  endDate: yup.string().required('Field is required'),
  workDays: yup
    .string()
    .required('Field is required')
    .nullable()
    .min(0, 'Min 1 day')
    .max(365, 'Max 365 days'),
  predecessors: predecessorsRule,
});

export const PhaseItemEditModalSchema = yup.object({
  phaseId: yup.number().required('Field is required'),
  title: yup.string().required('Field is required').max(100, 'Max 100 characters'),
  startDate: yup.string().required('Field is required'),
  endDate: yup.string().required('Field is required'),
  workDays: yup
    .string()
    .required('Field is required')
    .nullable()
    .min(0, 'Min 1 day')
    .max(365, 'Max 365 days'),
  predecessors: predecessorsRule,
});
